<div class="container" *ngIf="!isOcupacion">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="atras()">
            Volver
          </a>
        </div>
        <h3 class="page-title text-center">Catálogo del Programa Nacional de Aprendizaje</h3>
      </div>
    </div>
  </div>

  <div class="row mt-2" style="margin-bottom: 100px;">
    <ng-container *ngFor="let mt of motoresList">
      <div *ngIf="mt.imagen" class="col-md-3 col-12 pt-3 d-grid justify-content-center align-items-center">
        <div class="card puntero shadow-lg bg-body"
             [style]="'height: 300px;
                       width: 250px;
                       background-size: cover;
                       background-repeat: no-repeat;
                       background-image: url('+ url + mt.imagen + ')'"
             (click)="muestraOcupacion(mt)">
          <div class="card-body">
            <img [src]="url + mt.iconos" alt="" style="margin-top: 65px; margin-left: -25px; width: 100px" />
          </div>
        </div>
        <div class="card-footer text-dark fw-bold" style="max-width: 250px; text-align: center">
          <p class="fw-bold">{{ mt.nombre }}</p>
        </div>
      </div>
    </ng-container>
  </div>

  <app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

</div>


<app-lista-ocupacion *ngIf="isOcupacion"
[motor]="datos_motor"
(vuelve)="volver($event)"></app-lista-ocupacion>
